import React from 'react'
import NavBar from '../Components/NavBar'
import SimpleFooter from '../Components/SimpleFooter'


function HowItWorks() {
  return (
    <div>
        <div className='headerSectionHome'>
            <div className='opacity2'></div>
            <NavBar/>
            <div className='headerHomeText'>
                <h6>Redefining Digital Learning</h6>
                <h4>How It Works</h4>
            </div>
        </div>

        <section className='section6 howItWorksIntro'>
          <div className='sec6div1'>
            <div className='sec6div1A'></div>
          </div>
          <div className='sec6div2'>
            <h5>Reimagining how every student learns</h5>
            <h1>Ubunifu Smart Campus</h1>
            <div className='hiwIntroText'>
              <p>Ubunifu Smart Campus brings the best of the classroom online with live, interactive teaching that feels personal, engaging, and human. Instructors and students connect in real time from anywhere, creating a collaborative learning space that mirrors the energy of in‑person lessons.</p>
              <p>At the core is our Personal Language Model (PLM), an adaptive AI that learns how each student learns. It spots strengths, identifies challenges early, and delivers tailored guidance so progress stays steady and confidence stays high.</p>
              <p>This is more than a learning platform. It is a full digital campus that blends real-time instruction with AI personalization, helping students grow faster and stay on track in a modern, flexible learning environment.</p>
            </div>
          </div>
        </section>
        
        <section className='howItWorksSteps'>
          <div className='hiwStepsHeader'>
            <h5>How It Works</h5>
            <h2>Three connected layers of learning</h2>
            <p>We blend real-time teaching, adaptive AI, and always-on support to keep students progressing with clarity and confidence.</p>
          </div>
          <div className='hiwStepsGrid'>
            <article className='hiwStep hiwStep--img1'>
              <div className='hiwStepContent'>
                <span className='hiwStepNum'>01</span>
                <h5>Live Interactive Classes</h5>
                <p>Instructors and students log in from anywhere for real-time lessons, discussions, and shared workspaces, replicating the traditional classroom online.</p>
              </div>
            </article>
            <article className='hiwStep hiwStep--img2'>
              <div className='hiwStepContent'>
                <span className='hiwStepNum'>02</span>
                <h5>Personal Language Model (PLM)</h5>
                <p>Our adaptive PLM learns how each student thinks, then tailors guidance, feedback, and practice to accelerate mastery.</p>
              </div>
            </article>
            <article className='hiwStep hiwStep--plain'>
              <div className='hiwStepContent'>
                <span className='hiwStepNum'>03</span>
                <h5>Always-On Support + Global Collaboration</h5>
                <p>Students get 24/7 support while collaborating with peers worldwide on group projects, live discussions, and shared goals.</p>
              </div>
            </article>
          </div>
        </section>
        <SimpleFooter/>
    </div>
  )
}

export default HowItWorks
